import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import useStrings from "../../localization/useStrings"
import CyberMonday2025Header from "./CyberMonday2025Header/CyberMonday2025Header"
import styles from "./CyberMonday2025Paywall.module.scss"

const darkNavy = "#0F0F1A"
const darkPurple = "#2d2d51ff"
const purple = "#A855F7"
const cyan = "#5CE1E6"
const white = "#ffffff"
const textPrimary = "rgba(255, 255, 255, 0.9)"
const textSecondary = "rgba(255, 255, 255, 0.6)"

const cyberMonday2025Colors: SeasonalPaywallColors = {
  scrollableGradient: darkNavy,
  content: {
    background: darkNavy,
    ultimateContainerBackground: purple,
    ultimateContainerText: white,
    ultimateContainerMarginTop: "0px",
  },
  features: {
    icon: cyan,
    title: white,
    description: textSecondary,
    infoButton: cyan,
  },
  footer: {
    background: darkPurple,
    primaryButton: {
      background: purple,
      headerBackground: purple,
      contentBackground: darkNavy,
      limitedTimeText: textPrimary,
      saveTagText: textPrimary,
      planTitle: textPrimary,
      duration: textSecondary,
      originalPrice: textSecondary,
      discountedPrice: textPrimary,
      monthlyRate: textPrimary,
    },
    monthlyButton: {
      background: darkNavy,
      border: "none",
      label: textPrimary,
      price: textPrimary,
    },
  },
  insets: {
    header: darkNavy,
    footer: darkPurple,
  },
  closeButton: white,
}

const CyberMonday2025Paywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      customHeader={<CyberMonday2025Header />}
      footerBackground={
        <div
          className={styles.footerBackground}
          style={{ background: darkPurple }}
        />
      }
      colors={cyberMonday2025Colors}
      strings={{
        title: "",
        tagline: "",
        buttonTitle: strings.cyberMonday.saleTitle,
      }}
      topInsetPercent={0}
    />
  )
}

export default CyberMonday2025Paywall
